import { Component, NgModule, OnInit, Input, ChangeDetectorRef, Inject, PLATFORM_ID, NgZone, AfterViewInit, OnDestroy, LOCALE_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Page, Settings } from '../shared/navigation/pages.model';
import { SharedModule } from '../shared/shared.module';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/all';
import { isPlatformBrowser } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NavigationService } from '../shared/navigation/navigation.service';
import { take } from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { utils } from '../shared/helpers/utils';

@Component({
    templateUrl: 'lazy2.component.html',
    styleUrls: ['lazy2.component.scss'],
})

export class Lazy2Component implements OnInit, AfterViewInit, OnDestroy {
    public cdn = environment.cdn;
    public pageName = environment.name;
    public pageTitle: string;
    public pageContent: string;
    public gallery: any;
    public children: Page[] = [];
    public path_register = '/';
    public isMobile = true;
    
    private stage:any;
    private slides:any;
    private links:any;
    private slideID = 0;

    //form
    public form: FormGroup;
    public res = 0;
    public loading = false;
    public sent = false;
    public regulations = false;
    public settings: Settings = new Settings;
    public countries = utils.countries;

    constructor(@Inject(PLATFORM_ID) private platformId: Object, @Inject(LOCALE_ID) public localeId: string, private ngZone: NgZone, private router: Router, private route: ActivatedRoute, public fb: FormBuilder, private navigationService: NavigationService, private cdr: ChangeDetectorRef) {}

    ngOnInit() { 
        if (isPlatformBrowser(this.platformId)) {
        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(ScrollToPlugin);
        }
        this.createForm();
        this.path_register = this.router.config.find(x => x.data.id === -982).path;
        this.navigationService.navigation.subscribe(this.getSettings);

        this.navigationService.mobile.subscribe(mobile => {
            this.isMobile = mobile;
        });
    }
   
    getSettings = (menu: any) => {
     if (menu.menu.length) {
       // setTimeout(() => {
         this.settings = menu.settings;
       // }, 500);
     }
    }

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId) && !this.isMobile) {
            this.ngZone.runOutsideAngular(() => {
                // this.initHeader();
                const select = e => document.querySelector(e);
                const selectAll = e => document.querySelectorAll(e);
                this.stage = select('.stage');
                this.slides = selectAll(".slide");
                this.links = selectAll(".scroll-link-href");

                gsap.set(this.stage, { autoAlpha: 1 });
                this.initLinks();
                this.initSlides();
                this.initParallax();
            });
        }
    }

    private initSlides() {
    
        // Animation of each slide scrolling into view
        
        this.slides.forEach((slide, i) => {   
            
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    scrub: 1,
                    start: "0% 50%",
                    end: "50% 50%", 
                    // markers: {startColor: "green", endColor: "red", fontSize: "12px"}
                }
            });
     
            tl.from(slide.querySelectorAll('.slide-content-title'), {
                y: "+=5vh",
                ease: "power2",
                duration: 2.5,
            })
            .from(slide.querySelectorAll('.line-inner'), {
                x: -100,
                opacity: 0,
                duration: 2,
                ease: "power2",
                stagger: 0.1
            }, 0)
            .from(slide.querySelectorAll('.content-txt'), {
                y: 100,
                //y: 50,
                opacity: 0,
                duration: 2,
                ease: "power2"
            }, 0.4)
            .from(slide.querySelectorAll('.flat-button'), {
                y: 100,
                opacity: 0,
                duration: 2,
                ease: "power2"
            }, 0.3)
            .from(slide.querySelectorAll('.scroll-link'), {
                y: 100,
                duration: 2,
                ease: "power4"
            }, 0.4)
            // .to(slide.querySelectorAll('.slide__scroll-line'), {
            //     scaleY: 0.6,
            //     transformOrigin: "bottom left",
            //     duration: 2.5, 
            //     ease: "elastic(1,0.5)"
            // }, 1.4)

            
        });
    }
    
    private initParallax() {      
        this.slides.forEach((slide, i) => {
            let imageWrappers = slide.querySelectorAll('.image-wrap');
            
            gsap.fromTo(imageWrappers, {
                y: "-15vh"
            },{
                y: "15vh",
                scrollTrigger: {
                    trigger: slide,
                    scrub: true,
                    start: "top bottom",
                    // snap: {
                    //     snapTo: 0.5,
                    //     duration: 1,
                    //     ease: 'power4.inOut'
                    // }
                },
                ease: 'none'
            })
        });
    }

    private initLinks() {
    
        // ScrollToPlugin links
        
        this.links.forEach((link, index, e) => {     
            link.addEventListener("click", (e) => {
                e.preventDefault();
                gsap.to(window, {
                    duration: 2, 
                    scrollTo:{
                        y: (link.getAttribute("href") == '#slide0' ? 0 : link.getAttribute("href"))
                    },
                    ease: "power2.inOut"
                });
                this.slideID++;
            });
            
        });
    }

    private scrollTop() {
        gsap.to(window, {
            duration: 2, 
            scrollTo: {
                y: 0
            },
            ease: "power2.inOut"
        });
    }

    createForm() {
        if (this.localeId != 'pl') {
            this.countries.sort(function(a, b) {
                return a.viewValue.localeCompare(b.viewValue);
            });
        }
        this.form = this.fb.group({
            namesurname: [''], //honeypot
            from: ['Wiadomość z podstrony Współpraca B2B'], //honeypot
            email: ['', [Validators.required, Validators.email]],
            phone: ['', Validators.required],
            name: ['', Validators.required],
            company: ['', Validators.required],
            country: [this.localeId.toUpperCase(), Validators.required],
            postcode: [''],
            message: ['', Validators.required],
            rodo: ['', Validators.requiredTrue],
            newsletter: [''],

            utm_campaign: [this.route.snapshot.queryParamMap.get('utm_campaign')],
            utm_content: [this.route.snapshot.queryParamMap.get('utm_content')],
            utm_medium: [this.route.snapshot.queryParamMap.get('utm_medium')],
            utm_source: [this.route.snapshot.queryParamMap.get('utm_source')],
            utm_term: [this.route.snapshot.queryParamMap.get('utm_term')],

            form_name: ['Formularz współpraca B2B'],
            click: [this.navigationService.getClickId().value?.click]
        });
      }
    
      submit() {
        if (this.form.status === 'VALID') {
        this.loading = true;
        const formModel = this.form.value;
        this.navigationService.email(formModel).pipe(take(1)).subscribe((result: any) => {
            this.res = result.message;
            this.loading = false;
            this.sent = true;

            if((<any>window).dataLayer) {
                (<any>window).dataLayer.push({
                    event: 'form_submit',
                    form_name: 'B2B Cooperation',
                });
            }

            this.cdr.detectChanges();
          }, error => {
            this.res = 2;
            this.loading = false;
            this.cdr.detectChanges();
          }
        );
        } else {
          this.form.controls.rodo.markAsDirty();
        }
      }

    ngOnDestroy(): void {
        if (this.links) {
            this.links.forEach((link) => {     
                link.removeAllListeners('click');
            });
        }
        ScrollTrigger.getAll().forEach(t => t.kill());
        gsap.globalTimeline.getChildren().forEach(child => child.kill());
    }
    
}

@NgModule({
    declarations: [Lazy2Component],
    imports: [SharedModule, ReactiveFormsModule, MatInputModule, MatCheckboxModule, MatSelectModule] //mat-select wont work in children :/
})
class Lazy2Module { }